import React from 'react';

export default function SessionPromptModal({ message, onConfirm, onCancel }) {
  return (
    <div style={{
      position: 'fixed',
      top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: 9999,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '1.5rem',
        borderRadius: '8px',
        maxWidth: '360px',
        textAlign: 'center',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)'
      }}>
        <p style={{ fontSize: '1.1rem', marginBottom: '1rem', color: '#222' }}>{message}</p>
        <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem' }}>
          <button onClick={onConfirm} style={{ padding: '0.5rem 1rem' }}>Yes</button>
          <button onClick={onCancel} style={{ padding: '0.5rem 1rem' }}>No</button>
        </div>
      </div>
    </div>
  );
}
